import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <header className="header">
        <div className="container">
          <h1 className="company-name">Tran Tech Solutions LLC</h1>
          <p className="tagline">Privacy Policy</p>
          <Link to="/" className="back-link">← Back to Home</Link>
        </div>
      </header>

      <main className="main">
        <div className="container">
          <div className="policy-content">
            <p className="last-updated">Last Updated: October 5, 2025</p>

            <section className="policy-section">
              <h2>Introduction</h2>
              <p>
                Tran Tech Solutions LLC ("we," "our," or "us") is committed to protecting your privacy.
                This Privacy Policy explains our practices regarding the collection, use, and disclosure of
                information when you visit our website.
              </p>
            </section>

            <section className="policy-section">
              <h2>Information We Collect</h2>
              <p>
                <strong>We do not store any user information or personal data.</strong> Our application is designed
                with privacy in mind and does not maintain any databases or storage systems for user information.
              </p>
              <p>Specifically, we do not collect or store:</p>
              <ul>
                <li>Names, email addresses, or contact information</li>
                <li>Payment information or credit card details</li>
                <li>Personal identification information</li>
                <li>User account data</li>
                <li>Usage history or browsing data</li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>Payment Information</h2>
              <p>
                <strong>All payment processing is handled exclusively through Stripe, our third-party payment service provider.</strong>
                We do not process, store, or have access to any credit card or payment information.
              </p>
              <p>
                When you make a payment, you are redirected to Stripe's secure payment platform. Stripe handles all payment
                data in compliance with PCI-DSS standards. We never see or store your:
              </p>
              <ul>
                <li>Credit card numbers</li>
                <li>CVV/security codes</li>
                <li>Banking information</li>
                <li>Payment credentials of any kind</li>
              </ul>
              <p>
                For information about how Stripe handles your payment data, please review{' '}
                <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">Stripe's Privacy Policy</a>.
              </p>
            </section>

            <section className="policy-section">
              <h2>Third-Party Services</h2>
              <p>
                We use the following third-party services to operate our application:
              </p>
              <ul>
                <li>
                  <strong>Firebase Hosting (Google):</strong> Our website is hosted on Firebase Hosting. Firebase may collect
                  basic technical information such as IP addresses for hosting and security purposes. Please refer to{' '}
                  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google's Privacy Policy</a>{' '}
                  for information about how Firebase handles data.
                </li>
                <li>
                  <strong>Stripe:</strong> All payment processing is handled by Stripe. Stripe collects and processes payment
                  information necessary to complete transactions. We do not have access to this information. Please review{' '}
                  <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">Stripe's Privacy Policy</a>{' '}
                  for details on their data practices.
                </li>
              </ul>
            </section>

            <section className="policy-section">
              <h2>Contact Information</h2>
              <p>
                Our website displays contact information (email and phone number) for informational purposes.
                Any communication initiated through these contact methods occurs outside of this website, and
                this Privacy Policy does not apply to such communications.
              </p>
            </section>

            <section className="policy-section">
              <h2>Children's Privacy</h2>
              <p>
                Our website does not target or knowingly collect information from children under the age of 13.
                Since we do not collect any personal information, there is no risk of collecting children's data.
              </p>
            </section>

            <section className="policy-section">
              <h2>Changes to This Privacy Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with
                an updated "Last Updated" date. We encourage you to review this Privacy Policy periodically.
              </p>
            </section>

            <section className="policy-section">
              <h2>Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us:
              </p>
              <div className="contact-info">
                <p>📧 Email: support@trantechus.com</p>
                <p>📞 Phone: (650) 336-0577</p>
              </div>
            </section>

            <section className="policy-section">
              <h2>Your Rights</h2>
              <p>
                Since we do not collect, store, or process any personal information on our servers, there is no personal data
                maintained by us for you to access, correct, or delete.
              </p>
              <p>
                For any payment-related data inquiries, please contact Stripe directly as they are the independent data
                controller for all payment information.
              </p>
            </section>

            <section className="policy-section">
              <h2>Data Security</h2>
              <p>
                Because we do not store any user information or payment data, there is no risk of your personal or financial
                information being compromised through our systems. All sensitive payment data is securely handled by Stripe's
                PCI-compliant infrastructure.
              </p>
            </section>
          </div>
        </div>
      </main>

      <footer className="footer">
        <div className="container">
          <p>&copy; 2025 Tran Tech Solutions LLC. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;
